import Vue from "vue";
import Router from "vue-router";
import {
  PATH_LOGIN,
  PATH_INDEX,
  PATH_UPLOAD_IMG,
  PATH_AUDIT,
  PATH_EDIT,
  PATH_MANAGE,
  PATH_DETAILS,
  PATH_RESETPWD,
  PATH_RSETTAB,
  PATH_NEWS_LIST,
  PATH_NEWS_ADD,
  PATH_MESSAGE_LIST,
  PATH_MESSAGE_ADD
} from "@/constants/URL";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    { path: "/", redirect: PATH_LOGIN },
    {
      path: PATH_LOGIN,
      component: () => import("@/views/login/index.vue")
    },
    {
      path: PATH_RESETPWD,
      component: () => import("@/views/resetPwd/index.vue")
    },
    {
      path: PATH_INDEX,
      component: () => import("@/views/index/index.vue"),
      redirect: PATH_UPLOAD_IMG,
      children: [
        {
          path: PATH_UPLOAD_IMG,
          component: () => import("@/views/uploadImg/index.vue")
        },
        {
          path: PATH_AUDIT,
          component: () => import("@/views/audit/index.vue")
        },
        {
          path: PATH_EDIT,
          component: () => import("@/views/edit/index.vue")
        },
        {
          path: PATH_MANAGE,
          component: () => import("@/views/manage/index.vue")
        },
        {
          path: PATH_RSETTAB,
          component: () => import("@/views/setTab/index.vue")
        },
        {
          path: PATH_NEWS_LIST,
          component: () => import("@/views/news/list.vue")
        },
        {
          path: PATH_NEWS_ADD,
          component: () => import("@/views/news/addnew.vue")
        },
        {
          path: PATH_MESSAGE_LIST,
          component: () => import("@/views/message/list.vue")
        },
        {
          path: PATH_MESSAGE_ADD,
          component: () => import("@/views/message/addnew.vue")
        }
      ]
    },
    {
      path: PATH_DETAILS,
      component: () => import("@/views/details/index.vue")
    },

    {
      path: "*",
      name: "notfound",
      component: () => import("@/views/404.vue")
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router.js